(function() {
    "use strict";

    angular
        .module('ATMGCart', []);

})();


// WEBPACK FOOTER //
// ./src/app/modules/Cart/CartModule.js